import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ApiService {
  private http = inject(HttpClient);
  /** Strip trailing slash so `${base}/${path}` never doubles. */
  private baseUrl = environment.apiUrl.replace(/\/+$/, '');

  get<T>(
    path: string,
    query?: Record<string, string | number | boolean | undefined | null> | object
  ) {
    return this.http.get<T>(`${this.baseUrl}/${path.replace(/^\/+/, '')}`, {
      params: this.toHttpParams(query as Record<string, string | number | boolean | undefined | null> | undefined)
    });
  }

  post<T>(path: string, body: unknown) {
    return this.http.post<T>(`${this.baseUrl}/${path.replace(/^\/+/, '')}`, body);
  }

  put<T>(path: string, body: unknown) {
    return this.http.put<T>(`${this.baseUrl}/${path.replace(/^\/+/, '')}`, body);
  }

  patch<T>(path: string, body: unknown) {
    return this.http.patch<T>(`${this.baseUrl}/${path.replace(/^\/+/, '')}`, body);
  }

  delete<T>(path: string) {
    return this.http.delete<T>(`${this.baseUrl}/${path.replace(/^\/+/, '')}`);
  }

  private toHttpParams(
    query?: Record<string, string | number | boolean | undefined | null>
  ): HttpParams | undefined {
    if (!query) {
      return undefined;
    }
    let params = new HttpParams();
    Object.entries(query).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') {
        return;
      }
      params = params.set(key, String(value));
    });
    return params;
  }
}
